import * as React from "react";

const NISListIconActive: React.FC = () => {
    return (
        <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3.75 0.25H0.75C0.335438 0.25 0 0.585625 0 1V4C0 4.41456 0.335438 4.75 0.75 4.75H3.75C4.16437 4.75 4.5 4.4125 4.5 4V1C4.5 0.585625 4.16437 0.25 3.75 0.25ZM3.75 7.75H0.75C0.335438 7.75 0 8.0875 0 8.5V11.5C0 11.9146 0.335438 12.25 0.75 12.25H3.75C4.16437 12.25 4.5 11.9125 4.5 11.5V8.5C4.5 8.0875 4.16437 7.75 3.75 7.75ZM3.75 15.25H0.75C0.335438 15.25 0 15.5875 0 16V19C0 19.4146 0.335438 19.75 0.75 19.75H3.75C4.16437 19.75 4.5 19.4125 4.5 19V16C4.5 15.5875 4.16437 15.25 3.75 15.25ZM9 4H22.5C23.3283 4 24 3.32828 24 2.54219C24 1.75609 23.3297 1 22.5 1H9C8.17031 1 7.5 1.67172 7.5 2.45781C7.5 3.24391 8.17031 4 9 4ZM22.5 16H9C8.17172 16 7.5 16.6717 7.5 17.5C7.5 18.3283 8.17172 19 9 19H22.5C23.3283 19 24 18.3283 24 17.5C24 16.6717 23.3297 16 22.5 16ZM22.5 8.5H9C8.17031 8.5 7.5 9.17031 7.5 10C7.5 10.8297 8.17172 11.5 9 11.5H22.5C23.3283 11.5 24 10.8283 24 10C24 9.17172 23.3297 8.5 22.5 8.5Z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(NISListIconActive);
